import styles from "styles/pages/cdp/database-management.module.scss";

import { Checkbox } from "@components";
import classNames from "classnames/bind";
const css = classNames.bind(styles);

export default function Variable({ item, onSelect, selectedItems, icon }) {
  return (
    <div
      className={css({
        result: true,
        selected: selectedItems.includes(item),
      })}
      onClick={onSelect}
    >
      <div className="d-flex align-center">
        <div className={styles.icon}>{icon}</div>
        <p className={styles.name}>{item}</p>
      </div>
      <div className="d-flex align-center">
        <div className={styles.hairline} />
        <Checkbox
          design="two"
          value={item}
          checked={selectedItems.includes(item)}
          readOnly
        />
      </div>
    </div>
  );
}
